<template>
    <div class="animated fadeIn">
        <div>
            <b-row v-if="loading">
                <b-col md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-if="!loading">
            <b-row class="align-items-center mb-2">
                <b-col cols="7" md="9">
                    <h3 class="mb-1">Order Report</h3>
                </b-col>

                <b-col
                    cols="5"
                    md="3"
                    class="d-flex justify-content-end justify-content-sm-end justify-content-xs-start"
                >
                    <b-button
                        variant="primary"
                        class="w-auto d-inline-block"
                        @click="
                            $router.push({
                                path: '/analytics/history/ORDER',
                            })
                        "
                    >
                        View Download History
                    </b-button>
                </b-col>
            </b-row>

            <b-card>
                <b-row class="mt-1">
                    <b-col md="9" class="pt-0 pb-0">
                        <h4>Order Dashboard</h4>
                    </b-col>
                    <b-col
                        md="3"
                        class="pt-0 pb-0 align-items-right text-right"
                    >
                        <eb-select
                            ref="dateRef2"
                            class="select-background-white"
                            id="text"
                            type="text"
                            label="text"
                            :options="dateOption2"
                            v-model="selectedDate2"
                            :selected="selectedDate2.text"
                            @input="changeDate2"
                        >
                        </eb-select>
                        <c-date
                            ref="compRefs2"
                            modalRef="modalRef2"
                            modalId="dateModal2"
                            @customDateRange="findDateResult2"
                        ></c-date>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" class="mb-4">
                        <b-card class="total-order-header h-100">
                            <template #header>
                                <div
                                    class="d-flex justify-content-between align-items-center"
                                >
                                    <h4 class="text-white">Total Order</h4>
                                    <h3 class="text-white text-right">
                                        {{ totalOrder }}/{{ orderCount }}
                                    </h3>
                                </div>
                            </template>

                            <div
                                class="row py-2"
                                v-for="item in [
                                    {
                                        label: 'Pay on Delivery',
                                        amount: deliveryOrder,
                                        count: deliveryCount,
                                    },
                                    {
                                        label: 'Pre Paid',
                                        amount: prePaidOrder,
                                        count: prePaidOrderCount,
                                    },
                                    {
                                        label: 'Product',
                                        amount: productOrder,
                                        count: productOrderCount,
                                    },
                                    {
                                        label: 'Service',
                                        amount: serviceOrders,
                                        count: serviceCount,
                                    },
                                ]"
                                :key="item.label"
                            >
                                <h5 class="col-4 mb-1">{{ item.label }}</h5>
                                <h5 class="col-4 mb-1">रु {{ item.amount }}</h5>
                                <h5 class="col-4 mb-1">{{ item.count }}</h5>
                            </div>
                        </b-card>
                    </b-col>

                    <b-col cols="12" md="6" class="mb-4">
                        <b-card class="orderbyStatus-header h-100">
                            <template #header>
                                <div
                                    class="d-flex justify-content-between align-items-center"
                                >
                                    <h4 class="text-white">Order by Status</h4>
                                </div>
                            </template>

                            <div
                                class="row py-2"
                                v-for="item in [
                                    {
                                        label: 'Completed',
                                        amount: completedOrders,
                                        count: completedCount,
                                    },
                                    {
                                        label: 'Pending',
                                        amount: pendingOrders,
                                        count: pendingOrdersCount,
                                    },
                                    {
                                        label: 'Processing',
                                        amount: ongoingOrders,
                                        count: ongoingOrdersCount,
                                    },
                                    {
                                        label: 'Cancelled',
                                        amount: cancelledOrders,
                                        count: cancelledOrderCount,
                                    },
                                ]"
                                :key="item.label"
                            >
                                <h5 class="col-4 mb-1">{{ item.label }}</h5>
                                <h5 class="col-4 mb-1">रु {{ item.amount }}</h5>
                                <h5 class="col-4 mb-1">{{ item.count }}</h5>
                            </div>
                        </b-card>
                    </b-col>

                    <b-col cols="12" md="6" class="mb-4">
                        <b-card class="orderbySale-header h-100">
                            <template #header>
                                <div
                                    class="d-flex justify-content-between align-items-center"
                                >
                                    <h4 class="text-white">
                                        Order by Sales Channel
                                    </h4>
                                </div>
                            </template>

                            <div
                                class="row py-2"
                                v-for="item in [
                                    {
                                        label: 'POS',
                                        amount: posOrder,
                                        count: posOrderCount,
                                    },
                                    {
                                        label: 'Online',
                                        amount: onlineOrder,
                                        count: onlineOrderCount,
                                    },
                                ]"
                                :key="item.label"
                            >
                                <h5 class="col-4 mb-1">{{ item.label }}</h5>
                                <h5 class="col-4 mb-1">रु {{ item.amount }}</h5>
                                <h5 class="col-4 mb-1">{{ item.count }}</h5>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col md="6">
                        <b-row>
                            <b-col cols="9" md="3" class="mb-2 mb-md-0 chart-center">
                                <h5>Order by Status</h5>
                            </b-col>
                            <b-col cols="3" md="1">
                                <a href="#">
                                    <img
                                        src="@/assets/images/DataExport.png"
                                        class="upload-btn mb-0 mr-2"
                                        alt="data export"
                                        @click="createRequest"
                                    /> </a
                            ></b-col>
                            <b-col md="4">
                                <ev-select
                                    class="select-background-white"
                                    id="text"
                                    type="text"
                                    label="text"
                                    placeholder=" All Status"
                                    :options="statusOptions"
                                    v-model="selectedStatusOptions"
                                    :selected="selectedStatusOptions"
                                    @input="changeStatus"
                                >
                                </ev-select>
                            </b-col>
                            <b-col md="4">
                                <eb-select
                                    ref="dateRef"
                                    class="select-background-white"
                                    id="text"
                                    type="text"
                                    label="text"
                                    :options="dateOption"
                                    v-model="selectedDate"
                                    :selected="selectedDate.text"
                                    @input="changeDate"
                                >
                                </eb-select>
                                <c-date
                                    ref="compRefs"
                                    modalRef="modalRef"
                                    modalId="dateModal"
                                    @customDateRange="findDateResult"
                                ></c-date>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12" class="pt-0">
                                <b-card class="mt-0 card-full-height">
                                    <div
                                        v-if="
                                            getChartData &&
                                            getChartData.labels &&
                                            getChartData.labels.length > 0
                                        "
                                        class="mt-2 doughnut-center"
                                    >
                                        <Doughnut
                                            class="doughnut chart-doughnut"
                                            :chart-data="getChartData"
                                            :chart-options="chartOptions"
                                        >
                                        </Doughnut>
                                    </div>
                                    <div v-else class="chart-center">
                                        <h4 class="text-center no-data-margin">
                                            No Data Available
                                        </h4>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="4"> <h5>Order Value vs Order</h5></b-col>
                            <b-col md="4">
                                <ev-select
                                    class="select-background-white"
                                    id="text"
                                    type="text"
                                    label="text"
                                    :options="statusOptions"
                                    placeholder=" All Status"
                                    v-model="selectedStatusOptions1"
                                    :selected="selectedStatusOptions1"
                                    @input="changeStatus1"
                                >
                                </ev-select>
                            </b-col>
                            <b-col md="4">
                                <eb-select
                                    ref="dateRef1"
                                    class="select-background-white"
                                    id="text"
                                    type="text"
                                    label="text"
                                    :options="dateOption1"
                                    v-model="selectedDate1"
                                    :selected="selectedDate1.text"
                                    @input="changeDate1"
                                >
                                </eb-select>
                                <c-date
                                    ref="compRefs1"
                                    modalRef="modalRef1"
                                    modalId="dateModal1"
                                    @customDateRange="findDateResult1"
                                ></c-date>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12" class="pt-0">
                                <b-card class="mt-0 card-full-height">
                                    <div
                                        v-if="
                                            chartData &&
                                            chartData.labels &&
                                            chartData.labels.length > 0
                                        "
                                        class="mt-2"
                                    >
                                        <BarChart
                                            :chart-data="chartData"
                                            :chart-options="barChartOptions1"
                                            class="h-100"
                                        />
                                    </div>
                                    <div v-else>
                                        <h4 class="text-center no-data-margin">
                                            No Data Available
                                        </h4>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12" class="pt-0">
                        <b-row class="mt-3">
                            <b-col md="8" class="pb-0">
                                <h4>Order by Type</h4></b-col
                            >
                            <b-col md="1" class="text-right pb-0"> </b-col>
                            <b-col md="3" class="pb-0">
                                <eb-select
                                    ref="dateRef3"
                                    class="select-background-white"
                                    id="text"
                                    type="text"
                                    label="text"
                                    :options="dateOption3"
                                    v-model="selectedDate3"
                                    :selected="selectedDate3.text"
                                    @input="changeDate3"
                                >
                                </eb-select>
                                <c-date
                                    ref="compRefs3"
                                    modalRef="modalRef3"
                                    modalId="dateModal3"
                                    @customDateRange="findDateResult3"
                                ></c-date>
                            </b-col>
                        </b-row>
                        <b-card class="mt-0">
                            <div
                                v-if="
                                    orderByTypeChartData &&
                                    orderByTypeChartData.labels &&
                                    orderByTypeChartData.labels.length > 0
                                "
                            >
                                <BarChart
                                    :chart-data="orderByTypeChartData"
                                    :chart-options="barChartOptions"
                                />
                            </div>

                            <div v-else>
                                <h4 class="text-center my-5">
                                    No Data Available
                                </h4>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </b-card>
        </div>
    </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import moment from "moment";
import BarChart from "@/components/chart/BarChart";
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import Doughnut from "@/components/chart/Doughnut.js";
import doughChartDataGenerator from "@/utils/doughChartDataGenerator";
import orderListBarChartDataGenerator from "@/utils/orderListBarChartDataGenerator";
import generateOrderByTypeChartData from "@/utils/generateOrderByTypeChartData";
import cDate from "@/components/FormElements/CustomDate.vue";
import PieChart from "@/components/chart/newPieChart.vue";
import { AtomSpinner } from "epic-spinners";
import User from "@/views/userManagement/User.vue";

export default {
    name: "Reports",
    components: {
        BarChart,
        ComponentHeader,
        Doughnut,
        ebSelect,
        evSelect,
        cDate,
        AtomSpinner,
        PieChart,
    },
    data() {
        return {
            prevSelectedDate: null,
            prevSelectedDate1: null,
            prevSelectedDate2: null,
            prevSelectedDate3: null,
            loading: false,
            onlineOrder: 0,
            onlineOrderCount: 0,
            posOrder: 0,
            posOrderCount: 0,
            ongoingOrders: 0,
            ongoingOrdersCount: 0,
            pendingOrders: 0,
            pendingOrdersCount: 0,
            cancelledOrders: 0,
            cancelledOrderCount: 0,
            completedCount: 0,
            completedOrders: 0,
            serviceCount: 0,
            serviceOrders: 0,
            productOrder: 0,
            productOrderCount: 0,
            prePaidOrder: 0,
            prePaidOrderCount: 0,
            deliveryCount: 0,
            deliveryOrder: 0,
            totalCustomer: 0,
            totalOrder: 0,
            orderCount: 0,
            chartOptions: {
                hoverBorderWidth: 10,
            },
            selectedDate: {
                text: "Today",
                value: 1,
            },
            dateOption: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate: "",
            endDate: "",
            selectedDate1: {
                text: "Today",
                value: 1,
            },
            dateOption1: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate1: "",
            endDate1: "",
            selectedDate2: {
                text: "Today",
                value: 1,
            },
            dateOption2: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate2: "",
            endDate2: "",
            selectedDate3: {
                text: "Today",
                value: 1,
            },
            dateOption3: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate3: "",
            endDate3: "",
            barChartOptions1: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        position: "left",
                        title: {
                            display: true,
                            text: "Order Value",
                            font: {
                                size: 15,
                            },
                            color: "#002872",
                        },
                    },
                    y1: {
                        display: true,
                        position: "right",
                        title: {
                            display: true,
                            text: "Order Count",
                            font: {
                                size: 15,
                            },
                            color: "var(--primary)",
                        },
                        grid: {
                            drawOnChartArea: false,
                        },
                    },
                },
                plugins: {
                    title: {
                        position: "bottom",
                        display: true,
                        text: "Date",
                        font: {
                            size: 15,
                        },
                        color: "#",
                    },
                },
            },
            barChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: "index",
                    intersect: false,
                },
                scales: {
                    x: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            maxRotation: 45,
                            minRotation: 45,
                        },
                    },
                    y: {
                        beginAtZero: true,
                        display: true,
                        position: "left",
                        title: {
                            display: true,
                            text: "Order Amount",
                            font: {
                                size: 15,
                            },
                            color: "#002872",
                        },
                        ticks: {
                            callback(value) {
                                return new Intl.NumberFormat("en-US", {
                                    notation: "compact",
                                    maximumFractionDigits: 1,
                                }).format(value);
                            },
                        },
                    },
                    y1: {
                        beginAtZero: true,
                        display: true,
                        position: "right",
                        title: {
                            display: true,
                            text: "Order Count",
                            font: {
                                size: 15,
                            },
                            color: "var(--primary)",
                        },
                        grid: {
                            drawOnChartArea: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
                plugins: {
                    legend: {
                        position: "top",
                    },
                    tooltip: {
                        callbacks: {
                            label(context) {
                                const isCountAxis =
                                    context.dataset.yAxisID === "y1";
                                const value = context.parsed?.y || 0;
                                const formatter = new Intl.NumberFormat(
                                    "en-US",
                                    {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: isCountAxis
                                            ? 0
                                            : 2,
                                    },
                                );

                                return `${context.dataset.label}: ${formatter.format(
                                    value,
                                )}`;
                            },
                        },
                    },
                },
            },
            selectedStatusOptions: [],
            statusOptions: [
                "All Status",
                "Processing",
                "Delivered",
                "Created",
                "Out For Delivery",
                "Payment Failed",
                "Cancelled",
                "Rejected",
                "Returned",
                "Dispatched",
                "Refund",
                "Delivery Attached",
                "Confirmed",
            ],
            selectedStatusOptions1: [],
            selectedDate4: {
                text: "7 days",
                value: 6,
            }, 
           
            selectedDate5: {
                text: "7 days",
                value: 6,
            },
            startDate5: "",
            endDate5: "",
            selectedDate6: {
                text: "7 days",
                value: 6,
            },
            startDate6: "",
            endDate6: "",
            selectedCustomers: {
                text: "All",
                value: "All",
            },
        };
    },
    computed: {
        userId() {
            if (this.$store.getters["auth/getUserID"]) {
                return this.$store.getters["auth/getUserID"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
        },
        getChartData() {
            let dataList =
                this.$store.getters["partner/getBulkAnalyticsReport"];
            let dataKey = undefined;
            switch (true) {
                case this.$currentUserData.role === "Admin":
                    dataKey = "admin-orderbystatus-graph";
                    break;
                case this.$currentUserData.category === "TA":
                    dataKey = "orderbystatus-graph";
                    break;
                case this.$currentUserData.category === "SELLER":
                    dataKey = "seller-orderbystatus-graph";
                    break;
                default:
                    dataKey = "subdealer-orderbystatus-graph";
                    break;
            }
            return doughChartDataGenerator(dataList, dataKey);
        },
        chartData() {
            let data = this.$store.getters["partner/getChartData"];
            let orderKey = "";
            let orderAmount = "";
            let orderCount = "";
            if (this.$currentUserData.role === "Admin") {
                orderKey = "admin-orderbyvalue-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            } else if (this.$currentUserData.category === "TA") {
                orderKey = "orderbyvalue-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            } else if (this.$currentUserData.category === "SELLER") {
                orderKey = "seller-orderbyvalue-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                orderKey = "subdealer-orderbyvalue-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            }
            const orderList = data[orderKey];
            return orderListBarChartDataGenerator(
                orderList,
                orderAmount,
                orderCount,
            );
        },

        orderByTypeChartData() {
            let data = this.$store.getters["partner/GetOrderByTypeReport"];
            let posOrderKey = "";
            let posOrderAmount = "";
            let posOrderCount = "";
            let posDate = "";
            let posType = "";
            let onlineOrderKey = "";
            let onlineOrderAmount = "";
            let onlineOrderCount = "";
            let onlineDate = "";
            let onlineType = "";
            if (this.$currentUserData.role == "Admin") {
                posOrderKey = "admin-orderbytype-pos-graph";
                posOrderAmount = "orderamount";
                posOrderCount = "ordercount";
                posDate = "date";
                posType = "type";
                onlineOrderKey = "admin-orderbytype-online-graph";
                onlineOrderAmount = "orderamount";
                onlineOrderCount = "ordercount";
                onlineDate = "date";
                onlineType = "type";
            } else if (this.$currentUserData.category == "TA") {
                posOrderKey = "orderbytype-pos-graph";
                posOrderAmount = "orderamount";
                posOrderCount = "ordercount";
                posDate = "date";
                posType = "type";
                onlineOrderKey = "orderbytype-online-graph";
                onlineOrderAmount = "orderamount";
                onlineOrderCount = "ordercount";
                onlineDate = "date";
                onlineType = "type";
            } else if (this.$currentUserData.category === "SELLER") {
                posOrderKey = "seller-orderbytype-pos-graph";
                posOrderAmount = "orderamount";
                posOrderCount = "ordercount";
                posDate = "date";
                posType = "type";
                onlineOrderKey = "seller-orderbytype-online-graph";
                onlineOrderAmount = "orderamount";
                onlineOrderCount = "ordercount";
                onlineDate = "date";
                onlineType = "type";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                posOrderKey = "subdealer-orderbytype-pos-graph";
                posOrderAmount = "orderamount";
                posOrderCount = "ordercount";
                posDate = "date";
                posType = "type";
                onlineOrderKey = "subdealer-orderbytype-online-graph";
                onlineOrderAmount = "orderamount";
                onlineOrderCount = "ordercount";
                onlineDate = "date";
                onlineType = "type";
            }
            const posOrderList = data[posOrderKey];
            const onlineOrderList = data[onlineOrderKey];
            return generateOrderByTypeChartData(
                posOrderList,
                posOrderAmount,
                posOrderCount,
                posDate,
                posType,
                onlineOrderList,
                onlineOrderAmount,
                onlineOrderCount,
                onlineDate,
                onlineType,
            );
        },
        chartData4() {
            const dataList = this.$store.getters["partner/getSalesByTech"];
            const labels = [];
            const dataSets = [
                {
                    label: "Total Sales",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                    yAxisID: "y",
                },
                {
                    label: "Count Of Sales",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                    yAxisID: "y2",
                },
            ];

            if (dataList && dataList["sales-by-tech"]) {
                if (dataList["sales-by-tech"].length > 0) {
                    dataList["sales-by-tech"].map((el) => {
                        labels.push(el.Tech_Name);
                        dataSets[0].data.push(parseInt(el.total_sales));
                        dataSets[1].data.push(parseInt(el.count_of_sales));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions4() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y2: {
                        display: true,
                        beginAtZero: true,
                        suggestedMax: 3, // 👈 Adjusted to prevent stretching
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        position: "right",

                        ticks: {
                            display: false, // 👈 Ensure it only shows whole numbers
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        chartData5() {
            const dataList = this.$store.getters["partner/getSalesByRegion"];
            const labels = [];
            const dataSets = [
                {
                    label: "Total Customers",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                    yAxisID: "y",
                },
                {
                    label: "Total Sales",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                    yAxisID: "y2",
                },
            ];

            if (dataList && dataList["sales-by-region"]) {
                if (dataList["sales-by-region"].length > 0) {
                    dataList["sales-by-region"].map((el) => {
                        labels.push(el["Customer Region"]);
                        dataSets[0].data.push(parseInt(el.total_count));
                        dataSets[1].data.push(parseInt(el.total_sales));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions5() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y2: {
                        display: true,
                        beginAtZero: true,
                        suggestedMax: 3, // 👈 Adjusted to prevent stretching
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        // position: "right",

                        ticks: {
                            display: false, // 👈 Ensure it only shows whole numbers
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        pieData() {
            const isAllSelected =
                this.selectedCustomer &&
                this.selectedCustomer.toLowerCase() === "all";
            const data = this.$store.getters["partner/GetNumberOfDSO"];
            const dsoKey = isAllSelected ? "all-no-of-dso" : "no-of-dso";
            const labels = [];
            const dataSets = [
                {
                    data: [],
                    backgroundColor: [
                        // "#42A5F5", // Blue
                        "#FF6384", // Red
                        "#36A2EB", // Light Blue
                        "#FFCD56", // Yellow
                        // "#4CAF50", // Green
                        // "#FF9800", // Orange
                        // "#9C27B0", // Purple
                        // "#E91E63", // Pink
                        // "#2196F3", // Light Blue
                        // "#FFC107", // Amber
                    ],
                    hoverBackgroundColor: [
                        // "#64B5F6", // Hover Blue
                        "#FF8A80", // Hover Red
                        "#42A5F5", // Hover Light Blue
                        "#FFD54F", // Hover Yellow
                        // "#81C784", // Hover Green
                        // "#FFB74D", // Hover Orange
                        // "#BA68C8", // Hover Purple
                        // "#F06292", // Hover Pink
                        // "#64B5F6", // Hover Light Blue
                        // "#FFEB3B", // Hover Amber
                    ],
                },
            ];
            if (data && data[dsoKey]) {
                if (data[dsoKey].length > 0) {
                    data[dsoKey].map((el) => {
                        labels.push(el.Type);
                        dataSets[0].data.push(parseInt(el.num_of_invoices));
                        // dataSets[0].data.push(parseInt(el.total_amount));
                    });
                }
            }
            return {
                labels,
                datasets: dataSets,
            };
        },
        pieChartOptions() {
            const isAllSelected =
                this.selectedCustomer &&
                this.selectedCustomer.toLowerCase() === "all";
            const dsoKey = isAllSelected ? "all-no-of-dso" : "no-of-dso";
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: "top",
                    },
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                const data =
                                    this.$store.getters[
                                        "partner/GetNumberOfDSO"
                                    ];
                                if (data && data[dsoKey]) {
                                    const item = data[dsoKey].find(
                                        (el) => el.Type === tooltipItem.label,
                                    );
                                    if (item) {
                                        return `Total Amount: ${item.total_amount} No. of Invoice: ${item.num_of_invoices}`;
                                    }
                                }
                                // return tooltipItem.raw;
                            },
                        },
                    },
                    datalabels: {
                        anchor: "start",
                        align: "start",
                        formatter: (value, context) => {
                            const data =
                                this.$store.getters["partner/GetNumberOfDSO"];
                            const dsoKey = isAllSelected
                                ? "all-no-of-dso"
                                : "no-of-dso";
                            if (data && data[dsoKey]) {
                                const item = data[dsoKey].find(
                                    (el) =>
                                        el.Type ===
                                        context.chart.data.labels[
                                            context.dataIndex
                                        ],
                                );
                                if (item) {
                                    return `Total Amount: ${item.total_amount}\n No. of Invoice: ${item.num_of_invoices}`;
                                }
                            }
                        },
                    },
                },
            };
        },
        customerList() {
            let data = this.$store.getters["partner/getCustomerListData"];
            const customerDataList = data["customer-list"]
                ? data["customer-list"].map((d) => {
                      return {
                          text: d.Customer_Name,
                          value: d.Customer_Name,
                      };
                  })
                : [];
            customerDataList.unshift({ text: "All", value: "all" });
            return customerDataList;
        },
    },

    methods: {
        // Helper method to get API key prefix based on user role
        getApiKeyPrefix() {
            if (this.$currentUserData.role === "Admin") {
                return "admin-";
            } else if (this.$currentUserData.category === "TA") {
                return "";
            } else if (this.$currentUserData.category === "SELLER") {
                return "seller-";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                return "subdealer-";
            }
            return "";
        },
        // Helper method to get variables for API calls based on user role
        getApiVariables(additionalVars = {}) {
            const baseVars = {};
            if (this.$currentUserData.role === "Admin") {
                baseVars.tenant = this.$currentUserData.tenant;
            } else if (this.$currentUserData.category === "TA") {
                baseVars.tenant = this.userId;
            } else if (
                this.$currentUserData.category === "SELLER" ||
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                baseVars.userId = this.userId;
                baseVars.tenant = this.$currentUserData.tenant;
            }
            return { ...baseVars, ...additionalVars };
        },
        // Unified date data getter - accepts dateData, startDate prop name, and endDate prop name
        getDateDataGeneric(dateData, startDateProp, endDateProp) {
            if (dateData == "custom") {
                return {
                    fromDate: this[startDateProp],
                    toDate: this[endDateProp],
                };
            }
            if (dateData == 1) {
                return {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        // Helper method to assign dashboard data from API response
        assignDashboardData(data, prefix) {
            const getValue = (key) => {
                const fullKey = prefix ? `${prefix}${key}` : key;
                return data[fullKey];
            };

            // Handle Admin's "total-order" vs others' "total-orders"
            const totalOrderKey = prefix === "admin-" ? "total-order" : "total-orders";

            this.onlineOrder = (
                +getValue("online-orders")?.total_order_amount || 0
            ).toFixed(2);
            this.onlineOrderCount = getValue("online-orders")?.total_order || 0;
            this.posOrder = (
                +getValue("pos-orders")?.total_order_amount || 0
            ).toFixed(2);
            this.posOrderCount = getValue("pos-orders")?.total_order || 0;
            this.ongoingOrders = (
                +getValue("ongoing-orders")?.total_order_amount || 0
            ).toFixed(2);
            this.ongoingOrdersCount =
                getValue("ongoing-orders")?.total_order || 0;
            this.pendingOrders = (
                +getValue("pending-orders")?.total_order_amount || 0
            ).toFixed(2);
            this.pendingOrdersCount =
                getValue("pending-orders")?.total_order || 0;
            this.cancelledOrders = (
                +getValue("cancelled-orders")?.total_order_amount || 0
            ).toFixed(2);
            this.cancelledOrderCount =
                getValue("cancelled-orders")?.total_order || 0;
            this.completedCount =
                getValue("completed-orders")?.total_order || 0;
            this.completedOrders = (
                +getValue("completed-orders")?.total_order_amount || 0
            ).toFixed(2);
            this.serviceCount = getValue("service-orders")?.total_order || 0;
            this.serviceOrders = (
                +getValue("service-orders")?.total_order_amount || 0
            ).toFixed(2);
            this.productOrder = (
                +getValue("product-orders")?.total_order_amount || 0
            ).toFixed(2);
            this.productOrderCount =
                getValue("product-orders")?.total_order || 0;
            this.prePaidOrder = (
                +getValue("prepaid-orders")?.total_order_amount || 0
            ).toFixed(2);
            this.prePaidOrderCount =
                getValue("prepaid-orders")?.total_order || 0;
            this.deliveryCount = getValue("cod-orders")?.total_order || 0;
            this.deliveryOrder = (
                +getValue("cod-orders")?.total_order_amount || 0
            ).toFixed(2);
            this.totalOrder = (
                +getValue(totalOrderKey)?.total_order_amount || 0
            ).toFixed(2);
            this.orderCount = getValue(totalOrderKey)?.total_order || 0;
        },
        findDateResult2(e) {
            (this.startDate2 = e.fromDate),
                (this.endDate2 = e.toDate),
                this.dashboardReport();
        },
        changeDate2(e) {
            if (e.value === "custom") {
                this.prevSelectedDate2 = { ...this.selectedDate2 };
                this.selectedDate2 = this.prevSelectedDate2;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef2"] &&
                        this.$refs["dateRef2"].close
                    ) {
                        this.$refs["dateRef2"].close();
                    } else if (
                        this.$refs["dateRef2"] &&
                        this.$refs["dateRef2"].$el
                    ) {
                        const el =
                            this.$refs["dateRef2"].$el.querySelector("input") ||
                            this.$refs["dateRef2"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs2"].openModal();
                });
            } else {
                this.dashboardReport();
            }
        },
        getDateData(dateData) {
            return this.getDateDataGeneric(dateData, "startDate", "endDate");
        },
        getDateData2(dateData) {
            return this.getDateDataGeneric(dateData, "startDate2", "endDate2");
        },
        async dashboardReport() {
            const prefix = this.getApiKeyPrefix();
            const dateData = this.getDateData2(this.selectedDate2.value);
            const baseVariables = this.getApiVariables(dateData);
            
            // Define all the order report keys (Admin uses "total-order", others use "total-orders")
            const totalKey = prefix === "admin-" ? "total-order" : "total-orders";
            const orderKeys = [
                totalKey,
                "prepaid-orders",
                "online-orders",
                "cod-orders",
                "product-orders",
                "service-orders",
                "pending-orders",
                "completed-orders",
                "ongoing-orders",
                "cancelled-orders",
                "pos-orders",
            ];

            // Build payload items
            const payload = {
                items: orderKeys.map((key) => ({
                    key: prefix ? `${prefix}${key}` : key,
                    variables: baseVariables,
                })),
            };

            const data = await this.$store.dispatch(
                "partner/fetchBulkAnalyticReport",
                payload,
            );

            // Assign data using helper method
            this.assignDashboardData(data, prefix);
        },
        findDateResult(e) {
            (this.startDate = e.fromDate),
                (this.endDate = e.toDate),
                this.fetchOrderStatusChart();
        },
        changeDate(e) {
            if (e.value === "custom") {
                this.prevSelectedDate = { ...this.selectedDate };
                this.selectedDate = this.prevSelectedDate;
                this.$nextTick(() => {
                    if (this.$refs["dateRef"] && this.$refs["dateRef"].close) {
                        this.$refs["dateRef"].close();
                    } else if (
                        this.$refs["dateRef"] &&
                        this.$refs["dateRef"].$el
                    ) {
                        const el =
                            this.$refs["dateRef"].$el.querySelector("input") ||
                            this.$refs["dateRef"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs"].openModal();
                });
            } else {
                this.fetchOrderStatusChart();
            }
        },
        async fetchOrderStatusChart() {
            const prefix = this.getApiKeyPrefix();
            const dateData = this.getDateData(this.selectedDate.value);
            const statusData = this.getStatusData(this.selectedStatusOptions);
            const variables = this.getApiVariables({ ...dateData, ...statusData });

            const payload = {
                items: [
                    {
                        key: prefix ? `${prefix}orderbystatus-graph` : "orderbystatus-graph",
                        variables,
                    },
                ],
            };
            await this.$store.dispatch("partner/fetchBulkChart", payload);
        },

        findDateResult1(e) {
            (this.startDate1 = e.fromDate),
                (this.endDate1 = e.toDate),
                this.fetchOrderValueChart();
        },
        changeDate1(e) {
            if (e.value === "custom") {
                this.prevSelectedDate1 = { ...this.selectedDate1 };
                this.selectedDate1 = this.prevSelectedDate1;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].close
                    ) {
                        this.$refs["dateRef1"].close();
                    } else if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].$el
                    ) {
                        const el =
                            this.$refs["dateRef1"].$el.querySelector("input") ||
                            this.$refs["dateRef1"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs1"].openModal();
                });
            } else {
                this.fetchOrderValueChart();
            }
        },
        getDateData1(dateData) {
            return this.getDateDataGeneric(dateData, "startDate1", "endDate1");
        },
        changeStatus(e) {
            if (e.some((el) => el === "All Status")) {
                if (e.indexOf("All Status") === 0 && e.length > 1) {
                    e.splice(e.indexOf("All Status"), 1);
                    this.selectedStatusOptions = e;
                } else {
                    this.selectedStatusOptions = ["All Status"];
                }
            } else {
                this.selectedStatusOptions = e;
            }
            this.fetchOrderStatusChart();
        },
        getStatusData(statusData) {
            let data = {};
            if (
                statusData.length === 0 ||
                statusData.some((el) => el === "All Status")
            ) {
                this.statusOptions.forEach((el, index) => {
                    if (el !== "All Status") {
                        data[`status${index}`] = el;
                    }
                });
            } else {
                statusData.forEach((el, index) => {
                    data[`status${index + 1}`] = el;
                });
            }
            return data;
        },
        changeStatus1(e) {
            if (e.some((el) => el === "All Status")) {
                if (e.indexOf("All Status") === 0 && e.length > 1) {
                    e.splice(e.indexOf("All Status"), 1);
                    this.selectedStatusOptions1 = e;
                } else {
                    this.selectedStatusOptions1 = ["All Status"];
                }
            } else {
                this.selectedStatusOptions1 = e;
            }
            this.fetchOrderValueChart();
        },

        findDateResult3(e) {
            (this.startDate3 = e.fromDate),
                (this.endDate3 = e.toDate),
                this.fetchOrderByTypeChart();
        },
        changeDate3(e) {
            if (e.value === "custom") {
                this.prevSelectedDate3 = { ...this.selectedDate3 };
                this.selectedDate3 = this.prevSelectedDate3;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef3"] &&
                        this.$refs["dateRef3"].close
                    ) {
                        this.$refs["dateRef3"].close();
                    } else if (
                        this.$refs["dateRef3"] &&
                        this.$refs["dateRef3"].$el
                    ) {
                        const el =
                            this.$refs["dateRef3"].$el.querySelector("input") ||
                            this.$refs["dateRef3"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs3"].openModal();
                });
            } else {
                this.fetchOrderByTypeChart();
            }
        },
        getDateData3(dateData) {
            return this.getDateDataGeneric(dateData, "startDate3", "endDate3");
        },
        async fetchOrderByTypeChart() {
            const prefix = this.getApiKeyPrefix();
            const dateData = this.getDateData3(this.selectedDate3.value);
            const baseVariables = this.getApiVariables(dateData);

            const payload = {
                items: [
                    {
                        key: prefix ? `${prefix}orderbytype-pos-graph` : "orderbytype-pos-graph",
                        variables: baseVariables,
                    },
                    {
                        key: prefix ? `${prefix}orderbytype-online-graph` : "orderbytype-online-graph",
                        variables: baseVariables,
                    },
                ],
            };
            await this.$store.dispatch(
                "partner/fetchOrderByTypeChartReport",
                payload,
            );
        },

        async fetchOrderValueChart() {
            const prefix = this.getApiKeyPrefix();
            const dateData = this.getDateData1(this.selectedDate1.value);
            const statusData = this.getStatusData(this.selectedStatusOptions1);
            const variables = this.getApiVariables({ ...dateData, ...statusData });

            const payload = {
                items: [
                    {
                        key: prefix ? `${prefix}orderbyvalue-graph` : "orderbyvalue-graph",
                        variables,
                    },
                ],
            };
            await this.$store.dispatch("partner/fetchChart", payload);
        },
        createRequest() {
            const payload = {
                filterBy: {
                    ...this.getDateData(this.selectedDate.value),
                    collectionName: "ORDER",
                },
                requestBy: {
                    _id: this.$currentUserData._id,
                    name: this.$currentUserData.userName,
                    email: this.$currentUserData.email,
                    phone: this.$currentUserData.phone,
                },
            };
            this.$store
                .dispatch("partner/createRequestDownload", payload)
                .then(() => {
                    this.$swal({
                        title: "Success",
                        text: "Request successful!!",
                        type: "success",
                    });
                })
                .catch((error) =>
                    this.$toasted.error(
                        error.message
                            ? error.message
                            : "Error Request could not completed",
                    ),
                );
        },
        changeDate4(e) {
            this.selectedDate4 = e;
            if (e.value == "custom") {
                this.$refs["compRefs4"].openModal();
                return;
            }
            this.fetchSalesByTechData();
        },
        findDateResult4(e) {
            this.startDate4 = e.fromDate;
            this.endDate4 = e.toDate;
            this.fetchSalesByTechData();
        },

        getDateData4(dateData) {
            if (dateData == "custom") {
                return {
                    fromDate: this.startDate4,
                    toDate: this.endDate4,
                };
            }
            if (dateData == 1) {
                return {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchSalesByTechData() {
            const data = [
                {
                    key: "sales-by-tech",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData4(this.selectedDate4.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumnerSalesTech", {
                items: data,
            });
        },
        changeDate5(e) {
            this.selectedDate5 = e;
            if (e.value == "custom") {
                this.$refs["compRefs5"].openModal();
                return;
            }
            this.fetchSalesByRegionData();
        },
        findDateResult5(e) {
            this.startDate5 = e.fromDate;
            this.endDate5 = e.toDate;
            this.fetchSalesByRegionData();
        },

        getDateData5(dateData) {
            if (dateData == "custom") {
                return {
                    fromDate: this.startDate5,
                    toDate: this.endDate5,
                };
            }
            if (dateData == 1) {
                return {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchSalesByRegionData() {
            const data = [
                {
                    key: "sales-by-region",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData5(this.selectedDate5.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumnerSalesRegion", {
                items: data,
            });
        },
        changeDate6(e) {
            this.selectedDate6 = e;
            if (e.value == "custom") {
                this.$refs["compRefs6"].openModal();
                return;
            }
            this.changeCustomer();
        },
        findDateResult6(e) {
            this.startDate6 = e.fromDate;
            this.endDate6 = e.toDate;
            this.changeCustomer();
        },

        getDateData6(dateData) {
            if (dateData == "custom") {
                return {
                    fromDate: this.startDate6,
                    toDate: this.endDate6,
                };
            }
            if (dateData == 1) {
                return {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchNumberOfDSO(value) {
            this.isLoading = true;
            const data = [
                {
                    key: "no-of-dso",
                    variables: {
                        ...this.getDateData6(this.selectedDate6.value),
                        Customer: value.value,
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumberOfDSO", {
                items: data,
            });
            this.isLoading = false;
        },
        async fetchAllNumberOfDSO() {
            this.isLoading = true;
            const data = [
                {
                    key: "all-no-of-dso",
                    variables: {
                        ...this.getDateData6(this.selectedDate6.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumberOfDSO", {
                items: data,
            });
            this.isLoading = false;
        },

        async fetchCustomerList() {
            const data = [
                {
                    key: "customer-list",
                    variables: {},
                },
            ];
            await this.$store.dispatch("partner/fetchCustomerListData", {
                items: data,
            });
        },

        async changeCustomer(selected) {
            this.selectedCustomer = selected ? selected.value : "All";

            if (this.selectedCustomer.toLowerCase() === "all") {
                await this.fetchAllNumberOfDSO(selected);
            } else {
                await this.fetchNumberOfDSO(selected);
            }
        },
    },

    mounted() {
        this.changeCustomer();
        this.dashboardReport();
        this.fetchOrderStatusChart();
        this.fetchOrderValueChart();
        this.fetchOrderByTypeChart();
        this.fetchSalesByTechData();
        this.fetchSalesByRegionData();
        this.fetchCustomerList();
    },
};
</script>

<style scoped>
.total-order-header .card-header {
    background: var(--primary);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.orderbySale-header .card-header {
    background: var(--primary);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.orderbyStatus-header .card-header {
    background: var(--primary);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.card.total-order-header {
    height: 270px;
}

.card.orderbySale-header {
    height: 270px;
}

.card.orderbyStatus-header {
    height: 270px;
}

.total-order-header {
    margin-bottom: 25px !important;
}

.green-chart-icon i {
    background: #def6ee;
    text-align: center;
    color: #65d27d;
    border-radius: 5px;
    font-size: 16px !important;
    height: 36px;
    width: 36px;
    line-height: 36px;
}
.doughnut-center {
  display: flex;
  justify-content: center;   
  align-items: center;       
  min-height: 400px;
}

.chart-doughnut {
  max-width: 300px;
  max-height: 300px;
}




.red-chart-icon i {
    background: #f6dede;
    text-align: center;
    color: #fd8181;
    border-radius: 5px;
    font-size: 16px !important;
    height: 36px;
    width: 36px;
    line-height: 36px;
}

.order-price-heading {
    line-break: anywhere;
    line-height: 24px;
}

.chart-doughnut {
    height: 400px;
    width: 400px;
    margin-left: -5%;
}

@media (max-width: 480px) {
    .chart-doughnut {
        height: 260px;
        width: 260px;
        margin: 0 auto;
    }
}

@media (min-width: 481px) and (max-width: 768px) {
    .chart-doughnut {
        height: 300px;
        width: 300px;
        margin: 0 auto;
    }
}

.upload-btn {
    height: 39px;
    max-width: 36px;
    cursor: pointer;
}

.no-data-margin {
    margin-top: 196px;
    margin-bottom: 196px;
}

/* -----invoice css Start---- */
.invoice-data {
    margin: auto;
    border: 1px solid #aaaaaa;
    padding: 20px;
}
.invoice-data strong {
    font-size: 14px;
    font-weight: 600;
    color: #000;
}

.invoice-data div {
    font-size: 14px;
    font-weight: 400;
    color: #000;
}
.invoice-table {
    margin: auto;
    border: 1px solid #aaaaaa;
    padding: 20px;
    border-top: none;
    padding-top: 10px;
}
.invoice-table table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 0;
    border: none;
}
.invoice-table td {
    border: none;
    padding: 8px;
    text-align: left;
    font-size: 13px;
    font-weight: 400;
    color: #5f5d5f;
}
.invoice-table th {
    background-color: transparent;
    font-size: 14px;
    font-weight: 600;
    color: #000000;
    border: none;
    padding: 8px;
    text-align: left;
}
.invoice-table .description {
    width: 450px;
}

.select-background-white {
    background-color: #fff;
}

.card-full-height {
    height: 100%;
}

@media (max-width: 767.98px) {
    .card-full-height {
        height: auto;
        min-height: 300px;
    }
}
/* -----invoice css End---- */
</style>
